<h2>{{ 'APPOI.FEEDBACK_FORM.HEADLINE' | translate }}</h2>

<form (ngSubmit)="send()" [formGroup]="form">
  <div>
    <label [ngClass]="{
           'form-validated': dropdownCtrl.valid,
           'form-error': (dropdownCtrl.touched || sendFormClicked) && !dropdownCtrl.valid
           }"
           class="form-field-caption"
           id="dropdown-label"
    >
      {{ 'APPOI.FEEDBACK_FORM.TYPE_OF_REQUEST' | translate }}
      <span *ngIf="isRequired('dropdown')" aria-hidden="true">*</span>
      <span *ngIf="isRequired('dropdown')" class="visually-hidden">
        {{ 'APPOI.FEEDBACK_FORM.MANDATORY_HINT' | translate }}
      </span>
    </label>
    <mat-form-field [class.form-validated]="selected">
      <mat-select [(value)]="selected"
                  aria-labelledby="dropdown-label"
                  formControlName="dropdown"
                  required>
        <mat-option [value]="'OTHER_DATE'">
          {{ 'APPOI.FEEDBACK_FORM.TYPE_OF_REQUEST.OPTION_OTHER_DATE' | translate }}
        </mat-option>
        <mat-option [value]="'NO_SERVICE_CALL_REQUIRED'">
          {{ 'APPOI.FEEDBACK_FORM.TYPE_OF_REQUEST.OPTION_NO_SERVICE_CALL_REQUIRED' | translate }}
        </mat-option>
      </mat-select>
      <mat-icon [ngClass]="this.selected ? 'mat-icon-success' : 'mat-icon-invisible'" matSuffix>check_circle</mat-icon>
      @if (this.dropdownOpened) {
        <mat-icon matSuffix>expand_less</mat-icon>
      } @else {
        <mat-icon matSuffix>expand_more</mat-icon>
      }
      <mat-error *ngIf="isRequired('dropdown')">
        <mat-icon>warning</mat-icon>
        {{ 'APPOI.FEEDBACK_FORM.TYPE_OF_REQUEST.ERROR_HINT' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div *ngIf="showDatepicker">
    <label [ngClass]="{
           'form-validated': datepickerCtrl.valid,
           'form-error': (datepickerCtrl.touched || sendFormClicked) && !datepickerCtrl.valid
           }"
           class="form-field-caption"
           for="datepicker">
      {{ 'APPOI.FEEDBACK_FORM.DESIRED_DATE' | translate }}
      <span *ngIf="isRequired('datepicker')" aria-hidden="true">*</span>
      <span *ngIf="isRequired('datepicker')" class="visually-hidden">
        {{ 'APPOI.FEEDBACK_FORM.MANDATORY_HINT' | translate }}
      </span>
    </label>
    <mat-form-field [class.form-validated]="datepickerCtrl.valid">
      <input [attr.placeholder]="'APPOI.FEEDBACK_FORM.CHOOSE_DATE' | translate"
             [matDatepickerFilter]="excludeWeekends"
             [matDatepicker]="picker" [min]="minDate"
             formControlName="datepicker"
             id="datepicker"
             matInput required>
      <mat-datepicker-toggle [for]="picker" matSuffix>
        <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
      </mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
      <mat-error *ngIf="isRequired('datepicker')">
        <mat-icon>warning</mat-icon>
        {{ 'APPOI.FEEDBACK_FORM.CHOOSE_DATE.ERROR_HINT' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div>
    <label [class.form-validated]="isTextAreaValueLengthValid()"
           [ngClass]="{
          'form-validated': isTextAreaValueLengthValid(),
          'form-error': (textareaCtrl.touched || sendFormClicked) && !textareaCtrl.valid
          }"
           class="form-field-caption"
           for="textarea">
      {{ 'APPOI.FEEDBACK_FORM.REASON_FOR_REJECTION' | translate }}
      <span *ngIf="isRequired('textarea')" aria-hidden="true">*</span>
      <span *ngIf="isRequired('textarea')" class="visually-hidden">
        {{ 'APPOI.FEEDBACK_FORM.MANDATORY_HINT' | translate }}
      </span>
    </label>
    <mat-form-field [class.form-validated]="isTextAreaValueLengthValid()">
      <textarea formControlName="textarea"
                id="textarea"
                matInput
                maxlength="150"
                minlength="1"
                required
                rows="4"></textarea>
      <mat-hint [class.form-validated]="isTextAreaValueLengthValid()"
                align="end">{{ textareaValueLength }}/150
      </mat-hint>
      <mat-error *ngIf="isRequired('textarea')">
        <mat-icon>warning</mat-icon>
        {{ 'APPOI.FEEDBACK_FORM.REASON_FOR_REJECTION.ERROR_HINT' | translate }}
      </mat-error>
    </mat-form-field>
  </div>

  <div *ngIf="!hideSendButton" class="d-flex actions">
    <button class="vi-button"
            color="primary"
            mat-flat-button
            type="submit">{{ 'APPOI.BUTTON.SEND' | translate }}
    </button>
  </div>
</form>
